class PageDetail extends Component {
    constructor(el) {
        super(el);
        this.contactMapSection = this.$find('[data-contact-map-section]');
        this.contactMapAreas = null;
        this.contactMapPersonBoxes = null;
        this.activeClass = 'is-active';
        this.init();
    }

    setElements() {
        this.contactMapAreas = this.contactMapSection.querySelectorAll('[data-contact-map-area]');
        this.contactMapPersonBoxes = this.contactMapSection.querySelectorAll('[data-contact-map-person]');
    }

    resetPersonBoxes() {
        this.contactMapPersonBoxes.forEach(person => {
            person.classList.remove(this.activeClass);
        });
    }

    setPersonBoxActive(personBox) {
        personBox.classList.add(this.activeClass);
    }

    resetMapAreas() {
        this.contactMapAreas.forEach(area => {
            area.classList.remove(this.activeClass);
        });
    }

    setMapAreaActive(mapArea) {
        mapArea.classList.add(this.activeClass);
    }

    handleAreaMouseover(mapArea) {
        this.resetPersonBoxes();
        this.resetMapAreas();
        this.setMapAreaActive(mapArea);
        this.setPersonBoxActive([...this.contactMapPersonBoxes].find(box => box.dataset.area === mapArea.id));
    }

    addEventListeners() {
        this.contactMapAreas.forEach(mapArea => {
            mapArea.addEventListener("mouseover", () => {
                this.handleAreaMouseover(mapArea);
            });
        });
    }

    init() {
        if (this.contactMapSection) {
            this.setElements();
            this.addEventListeners();
        }
    }
}